import { get, post, upload } from './Global';

export type taskData = Partial<{
    REAL_NAME_INFO: any[],
    OFTEN_LOGIN_ADDR: string[],
    ONCE_USED_PASSWORD: string[],
    REGISTER_TIME: (string | number)[],
    REGISTER_ADDR: (string | number)[],
    ONCE_BIND_PHONE?: string[],
    CONTACTS?: string[],
    MAIL_TOPIC?: string[],
    PAY_ORDER?: string[]
}>;
interface IPostRepairTask {
    phone?: string,
    way: number,
    code: string,
    data: taskData,
    email: string,
    repairTimes?: number;
}

export const postRepairTask = ({ phone, way, code, data, email, repairTimes}: IPostRepairTask) => {
    return post('/fapi/task/add', {
        phone,
        way,
        code,
        data,
        email,
        repairTimes,
    })
}

export const uploadFile = (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return upload('/file/upload', formData)
}

interface ISmsVerifyCodeParams {
    phone?:string;
    safePhone?:boolean;
}
export const getSMSVerifyCode = (data: ISmsVerifyCodeParams) => {
    const params: ISmsVerifyCodeParams = {};
    data?.phone && (params.phone = data?.phone);
    data?.safePhone && (params.safePhone = data?.safePhone);
    return get('/sms/sendCode', params);
}

export const getCountryList = () => {
    return get('/area/country');
}

export const getProvinceList = (countryId: number) => {
    return get('/area/province', { id: countryId });
}

export const verifyPhone = (phone: string, code?: string | number) => {
    const paranms = code ? {
        phone,
        code
    } : {
        phone
    }
    return get('/sms/verifyPhone', paranms);
}

export const realNameInfoVerify = (phone: string, realNameInfo: any) => {
    return post('/fapi/realNameInfoVerify', {
        phone,
        realNameInfo
    });
}
